export {default} from './SpinampWalletIcon';
